import {apiClient} from "./api-client";
import type {components} from "./api-types";

// ============================================================================
// Types - re-exported from generated OpenAPI types
// ============================================================================

export type User = components["schemas"]["User"];

// ============================================================================
// API Functions
// ============================================================================

export async function getCurrentUser(): Promise<User> {
  const {data, error} = await apiClient.GET("/api/users/me");

  if (error || !data) {
    throw new Error((error as {detail?: string})?.detail || "Failed to fetch user profile");
  }

  return data;
}
